import "./App.css";

function App() {
  return (
    <>
      {/* Navbar */}
      <nav className="navbar">
        <div className="logo">Ketkar Bandhu Jewellers</div>
        <ul className="nav-links">
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About Us</a></li>
          <li><a href="#contact">Contact Us</a></li>
        </ul>
      </nav>

      {/* Hero Section */}
      <section className="hero" id="home">
        <h1>Timeless Jewellery for Every Generation</h1>
        <p>
          Crafted with trust, purity, and elegance for decades.
        </p>
      </section>

      {/* About Section */}
      <section className="section" id="about">
        <h2>About Us</h2>
        <p>
          Ketkar Bandhu Jewellers is a trusted name in fine jewellery,
          offering premium gold, diamond, and silver collections.
          Our craftsmanship blends traditional artistry with modern design,
          ensuring every piece reflects elegance and purity.
        </p>

        <div className="cards">
          <div className="card">
            <h3>Gold Jewellery</h3>
            <p>Hallmarked gold jewellery with exquisite craftsmanship.</p>
          </div>
          <div className="card">
            <h3>Diamond Jewellery</h3>
            <p>Certified diamonds designed to shine forever.</p>
          </div>
          <div className="card">
            <h3>Custom Designs</h3>
            <p>Create jewellery that tells your personal story.</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section contact" id="contact">
        <h2>Contact Us</h2>
        <p>Visit us or get in touch for personalized jewellery.</p>

        <div className="contact-info">
          <p><strong>📍 Address:</strong> Pune, Maharashtra</p>
          <p><strong>📞 Phone:</strong> +91 9XXXXXXXXX</p>
          <p><strong>✉ Email:</strong> info@ketkarbandhujewellers.com</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>© 2026 Ketkar Bandhu Jewellers. All Rights Reserved.</p>
      </footer>
    </>
  );
}

export default App;